import VuexORM from '@vuex-orm/core';
import Vue from 'vue';
import Vuex from 'vuex';
import {models} from '~/models';
import {appModule} from '~/store/app.module';
import {authModule} from '~/store/auth.module';
import {feedbackModule} from '~/store/feedback.module';
import {practiceModule} from '~/store/practice.module';
import {snackbarModule} from '~/store/snackbar.module';
import {testInstanceModule} from '~/store/test-instance.module';
import {testModule} from '~/store/test.module';

Vue.use(Vuex);

const database = new VuexORM.Database();
models.forEach(model => database.register(model));

const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app: appModule,
    feedback: feedbackModule,
    auth: authModule,
    snackbar: snackbarModule,
    test: testModule,
    practice: practiceModule,
    testInstance: testInstanceModule,
  },
});
export default store;
